// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","631":"contact"}[chunkId] + "." + {"443":"acebf273","631":"22197f2a"}[chunkId] + ".css";
};